import React from 'react';
import { StyleSheet, View } from 'react-native';
import theme from 'shared/styles/theme';

interface VerticalDashLineProps {
  dotLength: number;
  backgroundColor: string;
}

const VerticalDotLine = ({
  dotLength,
  backgroundColor = theme.color.background.overlay,
}: VerticalDashLineProps) => {
  const dotToRender = Array.from({ length: dotLength }, (_, index) => ({
    id: index,
  }));
  const dotStyle = { ...styles.dot, backgroundColor };
  return (
    <View style={styles.dashLineContainer} testID="dot">
      {dotToRender.map((dot) => (
        <View key={dot.id} style={dotStyle} />
      ))}
    </View>
  );
};

const styles = StyleSheet.create({
  dashLineContainer: {
    alignItems: 'center',
    flexDirection: 'column',
    gap: theme.spacing.xs,
  },
  dot: {
    borderRadius: 2.5,
    height: 2,
    width: 2,
  },
});

export default VerticalDotLine;
